import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

/**
 * İzin türleri ve personel izinleri (İnsan Kaynakları, 03.11.2026).
 * İzinli günde mesai hatırlatması gitmez, ek mesai talebinde seçilemez, puantajda izin kodu yazar.
 */

export interface IzinTuruItem {
    izinTuruId: string
    kod: string
    ad: string
    ucretli: boolean
    yillikIzindenDuser: boolean
    yasalGun: number | null
    sira: number
    aktif: boolean
    kullanimSayisi: number
    /** Liste ekranında satır seçimi (yalnız ekranda). */
    isSelected?: boolean
}

export interface IzinTuruKaydetIstegi {
    izinTuruId?: string | null
    kod: string
    ad: string
    ucretli: boolean
    yillikIzindenDuser: boolean
    yasalGun: number | null
    aktif: boolean
}

export interface IzinItem {
    izinId: string
    personnelId: string
    personelAdi: string | null
    izinTuruId: string
    kod: string
    turAdi: string
    ucretli: boolean
    /** "yyyy-MM-dd" */
    baslangic: string
    bitis: string
    /** "dd.MM.yyyy" */
    baslangicStr: string
    bitisStr: string
    gunSayisi: number
    aciklama: string | null
    giren: string | null
    tarih: string
    /** İK Faz 3: 1 Onaylı, 2 Onay bekliyor, 3 Reddedildi, 4 İptal edildi. Web'den girilen doğrudan onaylıdır. */
    durum: number
    durumAdi: string
    kararVeren: string | null
    kararZamani: string | null
    redNedeni: string | null
    /** Yıllık izinden düşen gün (hafta tatili ve resmi tatil hariç); düşmeyen türde boş. */
    dusenGun: number | null
    isSelected?: boolean
}

export const IZIN_ONAYLI = 1, IZIN_BEKLIYOR = 2, IZIN_REDDEDILDI = 3, IZIN_IPTAL = 4;

export const izinDurumSinifi = (durum: number) =>
    durum == IZIN_ONAYLI ? 'badge-light-success' : durum == IZIN_BEKLIYOR ? 'badge-light-warning' : durum == IZIN_REDDEDILDI ? 'badge-light-danger' : 'badge-light';

/** Yıllık izin bakiyesi (İş Kanunu md. 53). */
export interface IzinBakiyeItem {
    personnelId: string
    personelAdi: string | null
    iseGirisTarihi: string | null
    kidemYil: number
    yillikHak: number
    hakEdilen: number
    devreden: number
    kullanilan: number
    bekleyen: number
    kalan: number
    sonrakiHakTarihi: string | null
    uyari: string | null
}

export interface IzinKaydetIstegi {
    izinId?: string | null
    personnelId: string
    izinTuruId: string
    baslangic: string
    bitis: string
    aciklama: string | null
}

interface Yanit<T> { isSuccess: boolean, message?: string, data: T }

const cagir = async <T>(uc: string, govde: any = {}): Promise<Yanit<T>> => {
    try {
        console.log('SERVICE CALL - ' + uc, JSON.stringify(govde));
        const resp = await axios.post(Helpers.getEndpoint() + '/' + uc, govde);
        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class IzinService {
    /** İlk açılışta varsayılan türler (Yİ, Mİ, Eİ, Öİ, Bİ, R ...) yüklenir. */
    static turListesi = () => cagir<IzinTuruItem[]>('IzinTuru/GetList');
    static turKaydet = (istek: IzinTuruKaydetIstegi) => cagir<IzinTuruItem>('IzinTuru/Kaydet', istek);
    static turSil = (ids: string[]) => cagir<boolean>('IzinTuru/Sil', { ids });
    static liste = (baslangic: string, bitis: string) => cagir<IzinItem[]>('Izin/GetList', { baslangic, bitis });
    static kaydet = (istek: IzinKaydetIstegi) => cagir<IzinItem>('Izin/Kaydet', istek);
    static sil = (ids: string[]) => cagir<boolean>('Izin/Sil', { ids });
    /** Mobilden gelen izin isteğine karar; reddederken neden zorunlu. */
    static karar = (id: string, onay: boolean, redNedeni: string | null) => cagir<IzinItem>('Izin/Karar', { id, onay, redNedeni });
    static bakiyeler = (tarih?: string) => cagir<IzinBakiyeItem[]>('Izin/Bakiyeler', { tarih: tarih ?? null });
}
